// extracted by mini-css-extract-plugin
export default {"tile":"CampaignTile_tile__4Pn0l","logo":"CampaignTile_logo__qWsWr"};